import React from 'react'
import { Impact } from 'util/constants'
import PostCommentsTabs from 'components/Posts/display/PostCommentsTabs'

interface Props {
  impact: Impact
}

const ImpactProfileTabs = ({ impact }: Props) => (
  <PostCommentsTabs
    kind={impact.kind === 'teabate' ? "teabate" : "impact"}
    entityId={impact.id}
    entityTitle={impact.title}
  />
)

export default ImpactProfileTabs
